<template>
  <t-switch
    v-model="applyToAll"
    :label="label || $t('product.apply_to_all')"
  ></t-switch>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TSwitch } from "@topol/twig-ui";
  import { computed } from "vue";

  const props = defineProps({
    label: {
      type: String,
      default: "",
    },
    blockName: {
      type: String,
      default: "",
    },
  });

  const mjmlStore = useMjmlStore();

  const applyToAll = computed({
    get() {
      return mjmlStore.mjml.feedBlocksApplyToAll[props.blockName];
    },
    set(val: boolean) {
      mjmlStore.mjml.feedBlocksApplyToAll[props.blockName] = val;
    },
  });
</script>
